<template>
  <div class="wg-row">
    <!-- Filtro a tre colonne -->
    <div
      id="list-filter-btns"
      class="wg-row project-list-filter-btns wg-md-none"
    >
      <div
        v-for="(filterBtn, index) in filterBtns"
        :key="index"
        :class="'wg-col wg-xs-' + 12 / statusList.length"
      >
        <div
          :id="'list-filter-btn-' + filterBtn.id"
          :class="{ selected: selectedStatus === filterBtn.id }"
          @click="changeStatus(filterBtn.id)"
        >
          {{ filterBtn.label }}
        </div>
      </div>
    </div>
    <!-- Columns headers -->
    <div
      id="list-cols-labels"
      class="wg-row list-cols-labels"
      style="align-items:center;"
    >
      <div
        v-for="(filterBtn, index) in filterBtns"
        :key="index"
        :class="
          'wg-col wg-xs-' +
            12 / statusList.length +
            ' display-flex com-anm22-app-text-l'
        "
        style="font-weight:bold;justify-content:center;"
      >
        {{ filterBtn.label }}
      </div>
    </div>
    <div class="wg-row">
      <div
        v-for="(col, index) in customView.cols"
        :key="'kanban-col-' + index"
        :id="'status-projects-list-colid-' + col.id"
        :class="
          'wg-col wg-xs-12 wg-md-' +
            12 / customView.cols.length +
            ' status-projects-list com-anm22-app-scrolling-panel'
        "
        v-show="selectedStatus === col.id || windowWidth > 991"
        style="padding:0 5px;"
        @scroll="getNextProjects('colid-' + col.id)"
      >
        <template v-if="separateUrgent">
          <object-bar
            v-for="odata in colsObjectsData[col.id].urgent"
            :key="col.id + '-u-' + odata.id"
            :objectData="odata"
            :view="'cols'"
          ></object-bar>
          <div
            v-if="
              colsObjectsData[col.id].urgent.length &&
                colsObjectsData[col.id].notUrgent.length
            "
            class="separator"
          ></div>
          <object-bar
            v-for="odata in colsObjectsData[col.id].notUrgent"
            :key="'colid-' + col.id + '-' + odata.id"
            :objectData="odata"
            :view="'cols'"
          ></object-bar>
        </template>
        <object-bar
          v-else-if="colsObjectsData && colsObjectsData[col.id].all"
          v-for="odata in colsObjectsData[col.id].all.slice(
            0,
            projectsListsLimit['colid-' + col.id]
          )"
          :key="'colid-' + odata.id"
          :objectData="odata"
          :view="'cols'"
        ></object-bar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ObjectBar from "../project/ObjectBar.vue";

export default {
  components: {
    ObjectBar,
  },
  props: {
    projectsData: {
      type: Array,
      required: true,
    },
    customView: {
      type: Object,
      required: true,
      default: {
        id: null,
        type: "jobs",
        jobs: [],
      },
    },
    sortingFunctionGenerator: {
      type: Function,
      required: true,
    },
    separateUrgent: {
      type: Boolean,
      default: false,
    },
    orderingField: {
      type: String,
      default: "deadline",
    },
    orderingDir: {
      type: String,
      default: "ASC",
    },
  },
  data() {
    // Restore the column saved in the cookie, falling back to the first one
    const cols = this.customView.cols || [];
    const savedColId = this.$anm22.getCookie("tk_p_status");
    const selectedCol =
      cols.find((col) => String(col.id) === savedColId) || cols[0];
    return {
      selectedStatus: selectedCol ? selectedCol.id : null,
      projectsListLimit: 20,
      projectsListsLimit: {},
      objectsData: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
    }),
    viewJobs() {
      return this.customView.jobs;
    },
    statusList() {
      let statusList = [];
      this.customView.cols.forEach((col) => {
        statusList.push("colid-" + col.id);
      });
      return statusList;
    },
    colsObjectsData() {
      let colsObjectsData = {};

      this.customView.cols.forEach((col) => {
        let colContent = {
          all: this.objectsData.filter(col.rules),
          urgent: [],
          notUrgent: [],
        };

        if (this.separateUrgent) {
          colContent.urgent = colContent.all
            .filter((p) => p.urgent)
            .sort(
              this.sortingFunctionGenerator(
                this.orderingField,
                this.orderingDir
              )
            );
          colContent.notUrgent = colContent.all
            .filter((p) => !p.urgent)
            .sort(
              this.sortingFunctionGenerator(
                this.orderingField,
                this.orderingDir
              )
            );
        } else {
          colContent.all = colContent.all.sort(
            this.sortingFunctionGenerator(this.orderingField, this.orderingDir)
          );
        }

        colsObjectsData[col.id] = colContent;
      });

      return colsObjectsData;
    },
    filterBtns() {
      let filterBtns = [];
      this.customView.cols.forEach((col) => {
        filterBtns.push({
          id: col.id,
          label: col.name,
        });
      });
      return filterBtns;
    },
  },
  methods: {
    changeStatus(status) {
      this.selectedStatus = status;
      this.$anm22.setCookie("tk_p_status", status, 31536000);
    },
    getNextProjects(statusId) {
      const itemsNum = this.projectsListLimit;
      let bottomOfList =
        document.getElementById("status-projects-list-" + statusId).scrollTop +
          document.getElementById("status-projects-list-" + statusId)
            .clientHeight >=
        this.projectsListsLimit[statusId] * 43;
      if (bottomOfList) {
        this.projectsListsLimit[statusId] += itemsNum;
        console.log("Loading next projects...");
        this.$forceUpdate();
      }
    },
    checkListLimitAfterResize() {
      window.addEventListener(
        "resize",
        (event) => {
          if (window.innerHeight / 43 >= this.projectsListLimit) {
            this.projectsListLimit = Math.round(window.innerHeight / 43);
            console.log(
              "Resized kanbann to " + this.projectsListLimit + " items"
            );
          }
          this.statusList.forEach((status) => {
            if (this.projectsListsLimit[status] < this.projectsListLimit) {
              this.projectsListsLimit[status] = this.projectsListLimit;
            }
          });
        },
        true
      );
    },
    loadData() {
      this.$http
      .get(this.customView.endpoint)
      .then((response) => {
        if (response.data) {
          this.objectsData = response.data.objects;
        }
      })
      .catch((error) => console.log(error));
    },
  },
  created() {
    this.loadData();
    if (window.innerHeight / 43 >= this.projectsListLimit) {
      this.projectsListLimit = Math.round(window.innerHeight / 43);
      console.log("Resized kanbann to " + this.projectsListLimit + " items");
    }
    this.statusList.forEach((status) => {
      this.projectsListsLimit[status] = this.projectsListLimit;
    });
  },
};
</script>

<style lang="scss" scoped>
.separator {
  background-color: #fff;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
  border-bottom: 2px solid #ddd;
  margin-bottom: 8px;
  height: 1px;
}
.none {
  display: none;
}
.status-projects-list {
  max-height: calc(100vh - 270px);
}
@media screen and (max-width: 990px) {
  .status-projects-list {
    max-height: calc(100vh - 312px);
  }
}
</style>
